// Pardus pickup point data generated from pardus_directions.xlsx.
// Future postal-code matching placeholders:
// - postalCodes: exact postal codes served by the point, for example ["08001", "08002"].
// - postalPrefixes: broader postal prefixes served by the point, for example ["080", "081"].
// - address, latitude, and longitude are empty placeholders until Pardus provides them.
window.PardusPickupPoints = [
  {
    "id": "pardus-000",
    "name": "BIKETOKI Iker-I\u00f1aki",
    "city": "VITORIA GASTEIZ",
    "province": "ALAVA",
    "email": "biketoki@biketoki.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-001",
    "name": "LaFuga Cycling - LA FUGA SPAZIO- JOSE FRESCO",
    "city": "A CORU\u00d1A",
    "province": "A CORU\u00d1A",
    "email": "josefl.lafugacycling@perezrumbao.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-002",
    "name": "LaFuga Cycling (Santiago de Compostela)",
    "city": "SANTIAGO",
    "province": "A CORU\u00d1A",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-003",
    "name": "LaFuga Cycling Ourense",
    "city": "OURENSE",
    "province": "OURENSE",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-004",
    "name": "CONNECT BIKE - ASENSI BIKE Gustavo",
    "city": "SAN VICENTE DEL RASPEIG",
    "province": "ALICANTE",
    "email": "connect@asensibike.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-005",
    "name": "GUIJARRO TOT ESPORTS - Manolo y Javi",
    "city": "SAN VICENTE DEL RASPEIG",
    "province": "ALICANTE",
    "email": "pedidos@guijarrototesport.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-006",
    "name": "ATMOSFERA SPORT -Manolo",
    "city": "BANYERES DE MARIOLA",
    "province": "ALICANTE",
    "email": "matora73@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-007",
    "name": "GUIJARRO TOT SPORT IBI- BIKEIT S.L. - Jose",
    "city": "IBI",
    "province": "ALICANTE",
    "email": "xampibike@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-008",
    "name": "DOCTOR BIKE ELCHE - Rub\u00e9n",
    "city": "ELCHE",
    "province": "ALICANTE",
    "email": "doctorbikeelche@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-009",
    "name": "BIKEINGO WORKSHOP STORE - Yago",
    "city": "EL CAMPELLO",
    "province": "ALICANTE",
    "email": "bikeingoelcampello@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-010",
    "name": "CYCLING SPORT LLACER S.L. - JOSE MANUEL",
    "city": "VILLENA",
    "province": "ALICANTE",
    "email": "guijarrovillena@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-011",
    "name": "PEDAL BIKE SALVA SALVA",
    "city": "HUERCAL OVERA",
    "province": "ALMER\u00cdA",
    "email": "pedalbike1@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-013",
    "name": "RACEIT",
    "city": "BARCELONA",
    "province": "BARCELONA",
    "provinces": ["BARCELONA", "GIRONA", "LLEIDA", "TARRAGONA"],
    "email": "info@raceit.cc",
    "address": "Maria Auxiliadora, 9",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-017",
    "name": "R.J.O. BICICLETAS BURGOS S.L.",
    "city": "BURGOS",
    "province": "BURGOS",
    "email": "ciclosgarcia@ciclosgarcia.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-018",
    "name": "GOLDBIKES - ISMAEL",
    "city": "JEREZ DE LA FRONTERA",
    "province": "C\u00c1DIZ",
    "email": "info@goldbikes.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-019",
    "name": "2 RUEDAS SANTANDER - QUIQUE",
    "city": "SANTANDER",
    "province": "CANTABRIA",
    "email": "santander@2ruedas.net",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-020",
    "name": "LA PICOTA BIKE - FRAN",
    "city": "BEZANA",
    "province": "CANTABRIA",
    "email": "ventas@lapicotabike.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-021",
    "name": "RECICLOS - JUAN",
    "city": "ESCALANTE",
    "province": "CANTABRIA",
    "email": "reciclos@ymail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-022",
    "name": "FANDOS",
    "city": "VINAROS",
    "province": "CASTELL\u00d3N",
    "email": "ciclesfan2@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-023",
    "name": "CICLOS JABA - GABRIEL",
    "city": "VALL DE UX\u00d3",
    "province": "CASTELL\u00d3N",
    "email": "ciclosjaba2024@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-024",
    "name": "CICLOS FAUSTI - FAUSTINO",
    "city": "VILLAREAL",
    "province": "CASTELL\u00d3N",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-025",
    "name": "ADRENALINA SPORT - JOSE MIGUEL ESPADAS",
    "city": "PUENTE GENIL",
    "province": "CORDOBA",
    "email": "world-racing@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-026",
    "name": "TITAN BIKE SHOP - RAFAEL",
    "city": "C\u00d3RDOBA",
    "province": "C\u00d3RDOBA",
    "email": "ceo@titanbikeshop.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-027",
    "name": "HARMAN BIKES - ANTONIO",
    "city": "LUCENA",
    "province": "CORDOBA",
    "email": "antonioharmanbikes@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-029",
    "name": "CYCLOTRAVEL - FASTWHEELBIKE S.L. - ERIC",
    "city": "\u00cdILLORA",
    "province": "GRANADA",
    "email": "cyclotravelillora23@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-030",
    "name": "HARMAN BIKES - ANTONIO",
    "city": "GRANADA",
    "province": "GRANADA",
    "email": "antonioharmanbikes@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-031",
    "name": "OFF ROAD PARTS S.L. - FERNANDO",
    "city": "MANZANARES",
    "province": "CIUDAD REAL",
    "email": "bicicletas@offroadparts.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-032",
    "name": "CICLOS i2 BERGARA - JESUS",
    "city": "BERGARA",
    "province": "GUPUZCOA",
    "email": "ciclosi2bergara@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-033",
    "name": "BIKE SERVICE DONOSTI",
    "city": "SAN SEBASTI\u00c1N",
    "province": "GUPUZCOA",
    "email": "luis@bikeservicedonostia.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-034",
    "name": "CAMACHO SALAZAR - JOSE MAR\u00cdA",
    "city": "BOLLULLOS PAR DEL CONDADO",
    "province": "HUELVA",
    "email": "jsmcamacho@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-035",
    "name": "E-BIKE VALVERDE BICICLETAS - DAVID",
    "city": "VALVERDE DEL CAMINO",
    "province": "HUELVA",
    "email": "ebikevalverde@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-036",
    "name": "BERGANTI BIKES - Isaac",
    "city": "CAN PASTILLA",
    "province": "I. BALEARES",
    "email": "isaac@bergantibikes.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-037",
    "name": "FASSANELLI",
    "city": "ARTA",
    "province": "I. BALEARES",
    "email": "fassanelliarta@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-038",
    "name": "VADEBICIS - LA OROTAVA - Araceli",
    "city": "LA OROTAVA - TENERIFE",
    "province": "I. CANARIAS",
    "email": "info@vadebicis.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-039",
    "name": "Vadebicis Santa Cruz.",
    "city": "SANTA CRUZ - TENERIFE",
    "province": "I. CANARIAS",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-040",
    "name": "Vadebicis Lanzarote",
    "city": "ARRECIFE - LANZAROTE",
    "province": "I. CANARIAS",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-041",
    "name": "Vadebicis Chafiras.",
    "city": "CHAFIRAS - TENERIFE",
    "province": "I. CANARIAS",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-042",
    "name": "Vadebicis Telde.",
    "city": "TELDE - GRAN CANARIA",
    "province": "I. CANARIAS",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-043",
    "name": "Vadebicis La Palma",
    "city": "LA PALMA - LAS PALMAS",
    "province": "I. CANARIAS",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-044",
    "name": "KAMIKAZE BIKES - ROBERTO MARTEL",
    "city": "MASPALOMAS - LAS PALAMAS",
    "province": "I. CANARIAS",
    "email": "kamibike@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-045",
    "name": "RIDE BASE TENERIFE - ALBERTO",
    "city": "PUERTO LA CRUZ- TENERIFE",
    "province": "I. CANARIAS",
    "email": "info@ridebasetenerife.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-046",
    "name": "BOMBAY CYCLING BAILEN",
    "city": "BAILEN",
    "province": "JAEN",
    "email": "mmtienda@yahoo.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-047",
    "name": "BOMBAY CICLING LINARES",
    "city": "LINARES",
    "province": "JAEN",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-048",
    "name": "I`M BIKES - IMANOL MONTOYA",
    "city": "BAZA",
    "province": "JA\u00c9N",
    "email": "imbikesbaza@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-049",
    "name": "FS BIKE - JOSE",
    "city": "BAEZA",
    "province": "JA\u00c9N",
    "email": "info@fsbike.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-050",
    "name": "AD BIKES JAEN JAENEA ANTONIO",
    "city": "JA\u00c9N",
    "province": "JA\u00c9N",
    "email": "adbikesjaen@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-051",
    "name": "ROLLERBIKE S.L.",
    "city": "LOGRO\u00d1O",
    "province": "LA RIOJA",
    "email": "tiendarollerbike@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-052",
    "name": "BICICLETAS CARLOS - CARLOS",
    "city": "LE\u00d3N",
    "province": "LE\u00d3N",
    "email": "info@bicicletascarlos.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-055",
    "name": "CICLOS CORREDOR - PACO",
    "city": "MADRID",
    "province": "MADRID",
    "email": "paco@cicloscorredor.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-056",
    "name": "FOXIL BIKES - Roberto",
    "city": "VILLANUEVA DEL PARDILLO",
    "province": "MADRID",
    "email": "info@foxil.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-057",
    "name": "Mi BICIO JOSE S.L.",
    "city": "MADRID",
    "province": "MADRID",
    "email": "mibiciojose@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-058",
    "name": "RENT & ROLL - ROBERT",
    "city": "MADRID",
    "province": "MADRID",
    "email": "contact@rentandroll.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-059",
    "name": "SISQUIBIKES - SISQUI",
    "city": "MADRID",
    "province": "MADRID",
    "email": "sisquibikes@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-060",
    "name": "BICIMARKET CARTAYA - VER\u00d3NICA - ANTONIO",
    "city": "CARTAYA",
    "province": "M\u00c1LAGA",
    "email": "navarrobicis@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-061",
    "name": "DARKPEDAL SHOP (Eurobike) JAVI",
    "city": "CHURRIANA",
    "province": "M\u00c1LAGA",
    "email": "VENTAS@DARKPEDAL.COM",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-062",
    "name": "HARMAN BIKES - GERM\u00c1N",
    "city": "RONDA",
    "province": "MALAGA",
    "email": "germanharmanbikes@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-063",
    "name": "BIKEPHILOSOPHY S.L. SERGIO",
    "city": "M\u00c1LAGA",
    "province": "M\u00c1LAGA",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-064",
    "name": "BIKEPHILOSOPHY S.L. MARBELLA",
    "city": "MARBELLA",
    "province": "M\u00c1LAGA",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-065",
    "name": "BIKEPHILOSOPHY S.L. VELEZ M\u00c1LAGA",
    "city": "VELEZ M\u00c1AGA",
    "province": "M\u00c1LAGA",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-066",
    "name": "MUNDOBICI CARTAGENA - Tamara-Dani",
    "city": "CARTAGENA",
    "province": "MURCIA",
    "email": "info@mundobici.net",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-067",
    "name": "BICISPORT K2 - FRANCISCO JAVIER ABELLAN",
    "city": "JAVAL\u00cd VUEJO",
    "province": "MURCIA",
    "email": "franrk2@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-068",
    "name": "MANU BIKES- Manu",
    "city": "TORRES DE COTILLAS",
    "province": "MURCIA",
    "email": "manubiketorres@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-069",
    "name": "SENDAS BIKES ART - SERAFIN",
    "city": "ALGEZARES",
    "province": "MURCIA",
    "email": "sendasbikes@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-070",
    "name": "THE BIKE / Bicicletas Montoya",
    "city": "MURCIA",
    "province": "MURCIA",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-071",
    "name": "SANBIKES - JESUS AZNAR",
    "city": "CORTES",
    "province": "NAVARRA",
    "email": "sanbikesofficial@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-072",
    "name": "VENdeBICIS - FERNANDO",
    "city": "PAMPLONA",
    "province": "NAVARRA",
    "email": "vendebicis@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-073",
    "name": "LA FUGA CYCLING VIGO",
    "city": "VIGO",
    "province": "PONTEVEDRA",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-074",
    "name": "EXTREME CYCLE",
    "city": "PONTEAREAS",
    "province": "PONTEVEDRA",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-075",
    "name": "BIZIEBIKE - MIGUEL CARBALLO",
    "city": "PONTEAREAS",
    "province": "PONTEVEDRA",
    "email": "biziebike@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-076",
    "name": "SANSUEBIKE - Leo",
    "city": "SANTA MARTA DE TORMES",
    "province": "SALAMANCA",
    "email": "leo@sansuebike.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-077",
    "name": "CORRECAMINOS - JUAN CHIC\u00d3N MORENO",
    "city": "UTRERA",
    "province": "SEVILLA",
    "email": "iguana.30@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-078",
    "name": "D`ELITE BIKE CICLISMO - PEPE",
    "city": "ESTEPA",
    "province": "SEVILLA",
    "email": "delite_estepa@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-079",
    "name": "EXPOBIKES - MARCO",
    "city": "DOS HERMANAS",
    "province": "SEVILLA",
    "email": "info@expobikes.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-080",
    "name": "TU BICIO - MIGUEL",
    "city": "CANTILLANA",
    "province": "SEVILLA",
    "email": "tubicioh@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-081",
    "name": "BBP TALLER - BIEMBENIDO",
    "city": "OLIVARES",
    "province": "SEVILLA",
    "email": "bbptaller@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-082",
    "name": "CICLOPATA - Javi",
    "city": "LOS PALACIOS Y VILLAFRANCA",
    "province": "SEVILLA",
    "email": "ciclopata_cp@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-083",
    "name": "PREMIUM SHOPBIKE S.L.",
    "city": "CANALS",
    "province": "VALENCIA",
    "email": "premiumshopbike22@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-084",
    "name": "RALI",
    "city": "",
    "province": "VALENCIA",
    "email": "",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-085",
    "name": "BIKEPOBLA - LUIS MIGUEL",
    "city": "LA POBLA DE BALBONA",
    "province": "VALENCIA",
    "email": "info@bikepobla.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-086",
    "name": "CHE BICI - GUSTAVO",
    "city": "VALENCIA",
    "province": "VALENCIA",
    "email": "info@chebici.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-087",
    "name": "CICLOS GETXO - UNAI",
    "city": "GETXO",
    "province": "VIZCAYA",
    "email": "tienda@ciclosgetxo.net",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-088",
    "name": "LA BICICLETA - I\u00d1AKI",
    "city": "BILBAO",
    "province": "VIZCAYA",
    "email": "labicicletainaki@gmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-089",
    "name": "SIE CYCLING BRANDS S.L.",
    "city": "ZAMORA",
    "province": "ZAMORA",
    "email": "administracion@avaliente.es",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-090",
    "name": "ONDAS Y CORNUCOPIAS UNIP. LDA. - CAFE\u00c9&CYCLES - RUI",
    "city": "FARO",
    "province": "PORTUGAL",
    "email": "rui@rpcas.net",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-091",
    "name": "TRANSFORMIS LDA - NEW BIKE - BRUNO",
    "city": "BENEDITA-SANTAREM",
    "province": "PORTUGAL",
    "email": "brunorufinonewbike@hotmail.com",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-092",
    "name": "MANECAS BIKE - JOSE MANUEL DA COSTA HENRIQUES",
    "city": "SERT\u00c1 - CASTELLO BRANCO",
    "province": "PORTUGAL",
    "email": "manecas.bikes@sapo.pt",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  },
  {
    "id": "pardus-093",
    "name": "AVALANCHE CASCAIS - ROTA DAS RECIETAS UNIP. LDA - Anibal",
    "city": "CASCAIS - LISBOA",
    "province": "PORTUGAL",
    "email": "anibal@avalanche.pt",
    "address": "",
    "postalCodes": [],
    "postalPrefixes": [],
    "latitude": null,
    "longitude": null
  }
];
